import { QUERYSTRING_IFRAMEURL } from '../constants';
import { getQueryParameter } from './getQueryParameter';
export var isCurrentLocation = function isCurrentLocation(url) {
  if (!url) {
    return false;
  }
  var queryStringIndex = url.indexOf('?');
  var cleanUrl = queryStringIndex > -1 ? url.slice(0, queryStringIndex) : url;
  if (document.location.pathname === cleanUrl) {
    var currentIframeUrl = getQueryParameter(QUERYSTRING_IFRAMEURL);
    var urlSearch = queryStringIndex > -1 ? url.slice(queryStringIndex) : undefined;
    var urlQueryParameters = new URLSearchParams(urlSearch);
    var urlIframeUrl = urlQueryParameters.get(QUERYSTRING_IFRAMEURL);
    return currentIframeUrl === urlIframeUrl;
  }
  return false;
};